import React from 'react';

import HowItWorks from 'shared-components/HowItWorks/HowItWorks';

import styles from './HowRedeemWorks.module.css';

const HowRedeemWorks = () => {
  const HOW_REDEEM_WORKS_SECTIONS = [
    {
      icon: 'fal fa-envelope-open-text',
      title: 'Redeem Your Invite',
      copy: "Create a login to get started. It's free and there's no commitment to join!",
    },
    {
      icon: 'fal fa-shopping-bag',
      title: 'Shop the Sale',
      copy: `Share what's in your cart, chat about your favorite finds -- it's like a virtual trip to the mall!`,
    },
    {
      icon: 'fal fa-badge-dollar',
      title: 'Earn Credit',
      copy: 'Get a <strong>$10 credit</strong> to use in the sale when both you and the hosting member purchase a product.',
    },
    {
      icon: 'fal fa-smile',
      title: 'Get Excited',
      copy: 'Enjoy all your new products delivered straight to your doorstep. Your items will generally ship within 2 weeks of your bill date. ',
    },
  ];
  return (
    <>
      <p className={styles.subheader}>How It Works</p>
      <HowItWorks
        sections={HOW_REDEEM_WORKS_SECTIONS}
        className={styles.howRedeemWorks}
      />
    </>
  );
};

export default HowRedeemWorks;
